(function () {
  var root = document.getElementById('petsthing-whatsapp-widget');
  if (!root) return;

  var button = root.querySelector('.petsthing-wa__button');
  var panel = root.querySelector('.petsthing-wa__panel');
  var closeButton = root.querySelector('.petsthing-wa__close');
  var cta = root.querySelector('.petsthing-wa__cta');
  var storageKey = 'petsthing:whatsapp-widget';
  var hintTimer;

  function readState() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey)) || {};
    } catch (error) {
      return {};
    }
  }

  function writeState(nextState) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(nextState));
    } catch (error) {
      // localStorage can be unavailable in private browsing; the widget still works.
    }
  }

  function getWhatsAppUrl() {
    var phone = (root.dataset.phone || '').replace(/\D/g, '');
    var message = root.dataset.message || document.title || '';
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }

  function openPanel() {
    root.classList.add('is-open');
    root.classList.remove('show-hint');
    panel.setAttribute('aria-hidden', 'false');
    button.setAttribute('aria-expanded', 'true');
    writeState({ openedAt: Date.now() });
  }

  function closePanel() {
    root.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    button.setAttribute('aria-expanded', 'false');
    writeState({ closedAt: Date.now() });
  }

  function togglePanel() {
    if (root.classList.contains('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  }

  function showHintWhenHelpful() {
    var state = readState();
    var oneDay = 24 * 60 * 60 * 1000;
    var recentlyClosed = state.closedAt && Date.now() - state.closedAt < oneDay;
    var alreadyOpened = state.openedAt && Date.now() - state.openedAt < oneDay;

    if (recentlyClosed || alreadyOpened || root.classList.contains('is-open')) return;
    root.classList.add('show-hint');
    window.setTimeout(function () {
      root.classList.remove('show-hint');
    }, 6500);
  }

  if (cta) cta.href = getWhatsAppUrl();

  if (button) {
    button.addEventListener('click', togglePanel);
  }

  if (closeButton) {
    closeButton.addEventListener('click', closePanel);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      closePanel();
      button.focus();
    }
  });

  document.addEventListener('click', function (event) {
    if (!root.contains(event.target) && root.classList.contains('is-open')) {
      closePanel();
    }
  });

  ['scroll', 'mousemove', 'touchstart'].forEach(function (eventName) {
    window.addEventListener(eventName, function () {
      if (hintTimer) return;
      hintTimer = window.setTimeout(showHintWhenHelpful, 2500);
    }, { once: true, passive: true });
  });
})();
